export const tenDlcRegistrationLabel = ({ twilio10DlcRegistrationStatus, tenDlcData, t }) => {
  if (twilio10DlcRegistrationStatus && tenDlcData.providerStatus) {
    const status = tenDlcData.providerStatus.replace(/_/g, ' ').trim();
    const tenDlcStatus = status.charAt(0).toUpperCase() + status.substr(1).toLowerCase();
    return t('ten_dlc_status', '10DLC Registration ({{tenDlcStatus}})', {
      tenDlcStatus,
    });
  }
  return t('ten_dlc', '10DLC Registration');
};

export const show10DLCForm = ({
  handleTenDLCFormClick,
  twilio10DlcRegistrationStatus,
  tenDlcData,
  t,
}) => ({
  label: tenDlcRegistrationLabel({
    twilio10DlcRegistrationStatus,
    tenDlcData,
    t,
  }),
  onMenuItemClick: handleTenDLCFormClick,
});

export const onDLCModalClose = ({ handleShowScheduleMessageModal, dispatch, enableDlcForm }) => {
  handleShowScheduleMessageModal(false);
  dispatch(enableDlcForm(false));
};

export const handleSubmit = ({
  formData,
  requestToSubmit,
  customerId,
  id,
  customerIds,
  error,
  reformatDlcFormData,
  handleShowSuccessModal,
  handleShowScheduleMessageModal,
  handleShowSaveModal,
  dispatch,
  createDLCForm,
  handleResetErrorContainer,
  handleResetStepErrorArray,
}) => {
  const newFormData = reformatDlcFormData(formData);

  newFormData.customerId = customerId;
  newFormData.userId = id;
  newFormData.userRole = customerIds[0].role;
  if (!error) {
    if (requestToSubmit) {
      newFormData.requestToSubmit = true;
      handleShowSuccessModal(true);
      handleShowScheduleMessageModal(false);
      handleResetErrorContainer();
      handleResetStepErrorArray();
    } else {
      handleShowSaveModal(true);
    }
  }
  dispatch(createDLCForm({ formData: newFormData }));
};

export const STEP1_FIELDS = [
  'siteName',
  'country',
  'streetAddress1',
  'streetAddress2',
  'city',
  'region',
  'postalCode',
  'businessType',
  'companyStatus',
  'stockTicker',
  'stockExchange',
  'brandRepresentativeEmail',
  'businessRegistrationType',
  'businessRegistrationNumber',
  'brandRepresentativeEmail',
  'businessIndustry',
  'website',
  'regionsOfOperations',
  'socialMediaUrl',
  'privacyPolicyUrl',
  'termsAndConditionsUrl',
  'businessName',
  'address',
  'businessRegionsOfOperation',
];

export const STEP2_FIELDS = [
  'firstNamePOC1',
  'lastNamePOC1',
  'emailPOC1',
  'countryCodePOC1',
  'phoneNumberPOC1',
  'titlePOC1',
  'jobPositionPOC1',
  'firstNamePOC2',
  'lastNamePOC2',
  'emailPOC2',
  'countryCodePOC2',
  'phoneNumberPOC2',
  'titlePOC2',
  'jobPositionPOC2',
  'disablePOC2',
];

export const STEP3_FIELDS = [
  'campaignUseCaseDescription',
  'sampleMessage1',
  'sampleMessage2',
  'messageFlow',
];

const getErrorList = (errorFields) =>
  errorFields.map((errorField) => errorField.split('_').join(' '));

const checkIsStepError = ({ fields, errorField }) => {
  if (!errorField) {
    return false;
  }
  return fields.some(
    (field) => field.toLowerCase() === errorField.split('_').join('').toLowerCase(),
  );
};

const updateErrorContainerFields = ({ stepsArray, data }) => {
  const errorContainerFields = [];
  if (data.tenDlcErrors?.length) {
    data.tenDlcErrors.forEach((error) => {
      switch (true) {
        case checkIsStepError({
          fields: STEP1_FIELDS,
          errorField: error.errorFields[0],
        }):
          stepsArray.firstStep = true;
          errorContainerFields.push({
            labelName: 'Business Information',
            value: `${getErrorList(error.errorFields)} - ${error.description}`,
          });
          break;
        case checkIsStepError({
          fields: STEP2_FIELDS,
          errorField: error.errorFields[0],
        }):
          stepsArray.secondStep = true;
          errorContainerFields.push({
            labelName: 'Point Of Contact',
            value: `${getErrorList(error.errorFields)} - ${error.description}`,
          });
          break;
        case checkIsStepError({
          fields: STEP3_FIELDS,
          errorField: error.errorFields[0],
        }):
          stepsArray.thirdStep = true;
          errorContainerFields.push({
            labelName: 'Campaign Details',
            value: `${getErrorList(error.errorFields)} - ${error.description}`,
          });
          break;

        default:
          errorContainerFields.push({
            labelName: '',
            value: `${getErrorList(error.errorFields)} - ${error.description}`,
          });
          break;
      }
    });
  }
  return errorContainerFields;
};

/* The errorFields are expected when there are any errors found in Twilio integration process.
	It is expected to be fetched as errorFields : ["business name", "poc2: job position", "Address", "Brand Registration"] */
export const getErrorField = ({
  data,
  handleShowErrors,
  handleStepErrorArray,
  handleErrorContainer,
}) => {
  if (data.tenDlcErrors) {
    const stepsArray = {
      firstStep: false,
      secondStep: false,
      thirdStep: false,
    };

    const errorContainerFields = updateErrorContainerFields({
      stepsArray,
      data,
    });

    handleShowErrors(true);
    handleStepErrorArray(stepsArray);
    handleErrorContainer(errorContainerFields);
  }
};
